/* SEO copy read-more.

   The copy is clamped to a preview and the toggle reveals the full text. The
   toggle only appears when the copy actually overflows the clamp, so short
   collection descriptions render in full with no dangling control. */
(function () {
	const initSeoCopyReadMore = () => {
		const roots = document.querySelectorAll("[data-seo-copy-read-more]");

		roots.forEach((root) => {
			const text = root.querySelector("[data-seo-copy-text]");
			const toggle = root.querySelector("[data-seo-copy-toggle]");

			if (!text || !toggle) {
				return;
			}

			const overflows = text.scrollHeight - text.clientHeight > 1;

			if (!overflows) {
				text.classList.remove("seo-copy__body--clamped");
				toggle.hidden = true;
				return;
			}

			toggle.hidden = false;

			if (root.dataset.seoCopyBound === "true") {
				return;
			}
			root.dataset.seoCopyBound = "true";

			toggle.addEventListener("click", () => {
				const expanded = toggle.getAttribute("aria-expanded") === "true";

				text.classList.toggle("seo-copy__body--clamped", expanded);
				toggle.setAttribute("aria-expanded", String(!expanded));
				toggle.textContent = expanded
					? toggle.dataset.expandLabel
					: toggle.dataset.collapseLabel;
			});
		});
	};

	initSeoCopyReadMore();

	document.addEventListener("DOMContentLoaded", initSeoCopyReadMore);
	window.addEventListener("resize", initSeoCopyReadMore);
	document.addEventListener("shopify:section:load", initSeoCopyReadMore);
})();
